import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import AOS from "aos";
import "./Sms.css"
import { Link } from "react-router-dom";
import "aos/dist/aos.css";

const Sms = () => {
    const faqs = [
        {
            question: "What is AI SMS automation?",
            answer:
                "AI manages two-way text conversations, qualifies leads, resolves support – without manual effort.",
        },
        {
            question: "Can it handle real conversations?",
            answer:
                "Yes. TalkerIQ understands intent, context, and follow-ups – natural and human-like.",
        },
        {
            question: "Does it support bulk SMS?",
            answer:
                "Yes, both bulk campaigns and intelligent two-way AI replies.",
        },
        {
            question: "CRM integration?",
            answer:
                "Auto-sync conversations, create contacts, trigger workflows in real time.",
        },
        {
            question: "How fast is setup?",
            answer:
                "Under 15 minutes. No credit card required for trial.",
        },
        {
            question: "Is it TCPA compliant?",
            answer:
                "We provide tools for opt-ins, audit logs, and quiet hours — you manage consent.",
        },
    ];

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            {/* HERO SECTION (banner + grid + everything)  */}

            <section className="heros">
                <div className="hero-bg-pattern"></div>
                <div className="floating-bubble b1"></div>
                <div className="floating-bubble b2"></div>
                <div className="floating-bubble b3"></div>

                <div className="container">
                    <div className="hero-grid">

                        {/* left content */}
                        <div className="hero-left" data-aos="fade-right" >
                            <h1 style={{ fontSize: "2rem" }}>AI-Powered SMS Automation</h1>

                            <p>
                                Automate conversations. Qualify leads. Resolve support — all over SMS.
                                TalkerIQ’s AI helps you engage, qualify, and support customers over
                                text — instantly and at scale.
                            </p>

                            <div className="hero-stats">
                                <div className="stat-item">
                                    <span className="stat-number">5,432</span>
                                    <span className="stat-label">SMS</span>
                                </div>

                                <div className="stat-item">
                                    <span className="stat-number">{"<2s"}</span>
                                    <span className="stat-label">Response</span>
                                </div>

                                <div className="stat-item">
                                    <span className="stat-number">98%</span>
                                    <span className="stat-label">Open rate</span>
                                </div>
                            </div>

                            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                                <Link to={"/contact"}
                                    className="btn btn-primary"
                                >
                                    Book a Demo
                                </Link>

                                <Link to={"/contact"}
                                    className="btn btn-outline-light"
                                >
                                    Try SMS Agent
                                </Link>
                            </div>
                        </div>

                        {/* right chat preview */}
                        <div className="hero-right" data-aos="fade-left">
                            <div className="chat-stream">

                                <div className="chat-msg">
                                    <div className="avatar">
                                        <i className="fas fa-user"></i>
                                    </div>
                                    <div className="bubble">
                                        "Hey, I'm interested in your services"
                                        <span style={{ display: "block", fontSize: "0.75rem" }}>
                                            10:23 AM
                                        </span>
                                    </div>
                                </div>

                                <div className="chat-msg outgoing">
                                    <div className="avatar" style={{ background: "#2563eb" }}>
                                        <i className="fas fa-robot"></i>
                                    </div>
                                    <div className="bubble">
                                        "Hi! Are you looking for yourself or a business?"
                                    </div>
                                </div>

                                <div className="chat-msg">
                                    <div className="avatar">
                                        <i className="fas fa-user"></i>
                                    </div>
                                    <div className="bubble">
                                        "What's my order status?"
                                        <span style={{ display: "block", fontSize: "0.75rem" }}>
                                            10:25 AM
                                        </span>
                                    </div>
                                </div>

                                <div className="chat-msg outgoing">
                                    <div className="avatar" style={{ background: "#2563eb" }}>
                                        <i className="fas fa-robot"></i>
                                    </div>
                                    <div className="bubble">
                                        "Order #12345 is being processed and will ship tomorrow."
                                    </div>
                                </div>

                                <div className="chat-footer">
                                    <span>
                                        <i className="far fa-clock"></i> {"<2s"} avg reply
                                    </span>

                                    <span>
                                        <i className="fas fa-sync-alt"></i> 24/7 AI
                                    </span>

                                    <span>
                                        <i className="fas fa-database"></i> CRM sync
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* FEATURES (AI capabilities)  */}
            <section style={{ padding: "100px 0 50px" }}>
                <div className="container">
                    <h2 className="section-title" data-aos="fade-up">
                        Built on conversational AI
                    </h2>

                    <div className="features-grids">
                        <div className="feature-cards" data-aos="zoom-in">
                            <div className="feature-icon">
                                <i className="fas fa-magic"></i>
                            </div>
                            <h3>Smart questions</h3>
                            <p>Ask budget, timeline, need — just like a sales rep.</p>
                        </div>

                        <div
                            className="feature-cards"
                            data-aos="zoom-in"
                            data-aos-delay="50"
                        >
                            <div className="feature-icon">
                                <i className="fas fa-headset"></i>
                            </div>
                            <h3>24/7 Support</h3>
                            <p>Order status, FAQs, appointment booking.</p>
                        </div>

                        <div
                            className="feature-cards"
                            data-aos="zoom-in"
                            data-aos-delay="100"
                        >
                            <div className="feature-icon">
                                <i className="fas fa-cloud-upload-alt"></i>
                            </div>
                            <h3>CRM sync</h3>
                            <p>Real-time logging, lead scoring, webhooks.</p>
                        </div>

                        <div
                            className="feature-cards"
                            data-aos="zoom-in"
                            data-aos-delay="150"
                        >
                            <div className="feature-icon">
                                <i className="fas fa-clock"></i>
                            </div>
                            <h3>Auto follow-up</h3>
                            <p>Smart timing, personalized re-engagement.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* WHAT IS AI SMS? + COMPARISON GRID */}
            <section style={{ background: "#f6faff", padding: "90px 0" }}>
                <div className="container">
                    <div className="split-grid">

                        <div data-aos="fade-right">
                            <h2>What Is AI SMS Automation?</h2>

                            <p>
                                AI SMS Automation uses artificial intelligence to send, receive,
                                understand, and respond to text messages like a trained human — but
                                faster, 24/7, and without limits.
                            </p>

                            <p>
                                TalkerIQ’s AI agents ask smart follow-ups, qualify leads, answer
                                FAQs, book appointments, and route complex issues — all via SMS.
                            </p>

                            <div
                                style={{
                                    background: "white",
                                    borderRadius: "40px",
                                    padding: "25px",
                                    marginTop: "30px",
                                    boxShadow: "0 10px 20px rgba(0,0,0,0.02)"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "20px",
                                        alignItems: "center"
                                    }}
                                >
                                    <span
                                        style={{
                                            background: "#2563eb",
                                            color: "white",
                                            padding: "10px 18px",
                                            borderRadius: "50px"
                                        }}
                                    >
                                        98% open
                                    </span>

                                    <span
                                        style={{
                                            background: "#2563eb",
                                            color: "white",
                                            padding: "10px 18px",
                                            borderRadius: "50px"
                                        }}
                                    >
                                        {"<2s"} reply
                                    </span>

                                    <span
                                        style={{
                                            background: "#2563eb",
                                            color: "white",
                                            padding: "10px 18px",
                                            borderRadius: "50px"
                                        }}
                                    >
                                        10x faster
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="comparison-card" data-aos="fade-left">
                            <h3 style={{ marginBottom: "30px" }}>
                                TalkerIQ vs traditional SMS tools
                            </h3>

                            <div className="comp-row">
                                <span className="comp-feature">Conversation style</span>
                                <span className="comp-traditional">Static auto-reply</span>
                                <span className="comp-talker">
                                    <i className="fas fa-check"></i> Context-aware AI
                                </span>
                            </div>

                            <div className="comp-row">
                                <span className="comp-feature">Follow-ups</span>
                                <span className="comp-traditional">Manual</span>
                                <span className="comp-talker">
                                    <i className="fas fa-check"></i> Fully automated
                                </span>
                            </div>

                            <div className="comp-row">
                                <span className="comp-feature">Intent detection</span>
                                <span className="comp-traditional">None</span>
                                <span className="comp-talker">
                                    <i className="fas fa-check"></i> Real-time understanding
                                </span>
                            </div>

                            <div className="comp-row">
                                <span className="comp-feature">Replies</span>
                                <span className="comp-traditional">Human only</span>
                                <span className="comp-talker">
                                    <i className="fas fa-check"></i> AI + human handoff
                                </span>
                            </div>

                            <div className="comp-row">
                                <span className="comp-feature">CRM sync</span>
                                <span className="comp-traditional">Manual export</span>
                                <span className="comp-talker">
                                    <i className="fas fa-check"></i> Bi-directional real-time
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* USE CASES (grid)  */}
            <section style={{ padding: "90px 0" }}>
                <div className="container">
                    <h2 className="sections-title">Use cases · AI SMS in action</h2>

                    <div className="usecase-grid">
                        <div className="usecase-card">
                            <i className="fas fa-filter"></i>
                            <h3>Lead qualification</h3>
                            <p>Ask budget, timeline, auto-score, push to sales.</p>
                        </div>

                        <div className="usecase-card">
                            <i className="fas fa-life-ring"></i>
                            <h3>Support automation</h3>
                            <p>Order status, FAQs, troubleshooting, instant answers.</p>
                        </div>

                        <div className="usecase-card">
                            <i className="fas fa-calendar-alt"></i>
                            <h3>Appointment booking</h3>
                            <p>Two-way scheduling, reminders, confirmations.</p>
                        </div>

                        <div className="usecase-card">
                            <i className="fas fa-bullhorn"></i>
                            <h3>Bulk + two-way</h3>
                            <p>Campaigns that continue conversation, no black hole.</p>
                        </div>

                        <div className="usecase-card">
                            <i className="fas fa-truck"></i>
                            <h3>Order updates</h3>
                            <p>Shipping confirmations, delivery notifications.</p>
                        </div>

                        <div className="usecase-card">
                            <i className="fas fa-ticket-alt"></i>
                            <h3>Event registration</h3>
                            <p>RSVP, reminders, post-event follow-up.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* COMPLIANCE / CHECKLIST (inspired by original) */}
            <section style={{ background: "#f1f5f9", padding: "90px 0" }}>
                <div className="container">
                    <h2 className="sections-title">SMS compliance built-in</h2>

                    <div className="checklist-grid">
                        <div className="check-item">
                            <i className="fas fa-check-circle"></i>
                            <h4>Opt-in & consent</h4>
                            <p>Capture express written consent via web, keyword, or verbal.</p>
                        </div>

                        <div className="check-item">
                            <i className="fas fa-check-circle"></i>
                            <h4>Program details</h4>
                            <p>Business name, message cadence, terms at signup.</p>
                        </div>

                        <div className="check-item">
                            <i className="fas fa-check-circle"></i>
                            <h4>Quiet hours</h4>
                            <p>No texts before 8am or after 9pm (automated).</p>
                        </div>

                        <div className="check-item">
                            <i className="fas fa-check-circle"></i>
                            <h4>Audit trail</h4>
                            <p>Full logs for TCPA compliance & reporting.</p>
                        </div>

                        <div className="check-item">
                            <i className="fas fa-check-circle"></i>
                            <h4>Opt-out mgmt</h4>
                            <p>Automatic STOP handling and confirmation.</p>
                        </div>

                        <div className="check-item">
                            <i className="fas fa-check-circle"></i>
                            <h4>Business name</h4>
                            <p>Every message identifies your brand.</p>
                        </div>
                    </div>

                    <p
                        className="text-center"
                        style={{ marginTop: "40px", fontStyle: "italic" }}
                    >
                        *This is not legal advice. You are 100% responsible for compliance.
                    </p>
                </div>
            </section>
            {/* <!-- ===== FAQ SECTION ===== --> */}
            <section style={{ padding: "100px 0" }}>
                <div className="container">
                    <h2 className="sections-title">Frequently asked questions</h2>

                    <div className="sms-faq-grid">
                        {faqs.map((faq, index) => (
                            <div className="faq-item" key={index}>
                                <h4>{faq.question}</h4>
                                <p>{faq.answer}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* <!-- ===== FINAL CTA (banner) ===== --> */}
            <section style={{ padding: "70px 0 100px" }}>
                <div className="container">
                    <div className="cta-block" data-aos="zoom-in">
                        <h2>Turn SMS into your highest-converting channel</h2>

                        <p
                            style={{
                                fontSize: "1.2rem",
                                maxWidth: "700px",
                                margin: "20px auto",
                            }}
                        >
                            TalkerIQ helps you sell, support, and scale using AI-powered SMS —
                            without increasing headcount.
                        </p>

                        <div
                            style={{
                                display: "flex",
                                gap: "20px",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                marginTop: "40px",
                            }}
                        >
                            <Link to={"/contact"}
                                className="btn btn-primary"
                                style={{ background: "white", color: "#0f2b4b" }}
                            >
                                Start automating SMS today
                            </Link>

                            <Link to={"/contact"}
                                className="btn btn-outline-light"
                            >
                                Try SMS Agent free
                            </Link>
                        </div>

                        <p style={{ marginTop: "30px", opacity: 0.8 }}>
                            No credit card · 15-minute setup
                        </p>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default Sms;